/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  CREATE_DRAFT_ROE_APPLICATION_SUCCESS: {
    message: 'Application drafted Successfully',
  },
  CREATE_DRAFT_ROE_APPLICATION_ERROR: {
    message: 'Failed to draft application',
  },
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.jamaica.roeworkPermitDraft',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        MUTATE: { target: 'INITIATE_CREATE_DRAFT_ROE_APPLICATION' },
      },
    },
    INITIATE_CREATE_DRAFT_ROE_APPLICATION: {
      invoke: {
        id: 'roeCompanySubmit',
        src: 'roeCompanySubmit',
        onDone: {
          target: 'CREATE_DRAFT_ROE_APPLICATION_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'CREATE_DRAFT_ROE_APPLICATION_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    CREATE_DRAFT_ROE_APPLICATION_SUCCESS: {
      //type: "final",
      on: {
        MUTATE: { target: 'INITIATE_CREATE_DRAFT_ROE_APPLICATION' },
      },
    },
    CREATE_DRAFT_ROE_APPLICATION_ERROR: {
      //type: "final",
      on: {
        MUTATE: { target: 'INITIATE_CREATE_DRAFT_ROE_APPLICATION' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
